/**
 * New → seen (motion 4) persists per user: ids the rows report seen are batched and sent to
 * POST /api/dashboard/seen; the Worker folds them into the next Following snapshot (isNew: false).
 */
const pending = new Set<string>();
let timer: ReturnType<typeof setTimeout> | undefined;
const BATCH_MS = 800;

function flush(beacon = false) {
  clearTimeout(timer);
  if (!pending.size) return;
  const body = JSON.stringify({ matchIds: [...pending] });
  pending.clear();
  if (beacon && navigator.sendBeacon?.("/api/dashboard/seen", new Blob([body], { type: "application/json" }))) return;
  void fetch("/api/dashboard/seen", { method: "POST", credentials: "include", headers: { "content-type": "application/json" }, body, keepalive: true }).catch(() => {});
}

export function persistSeen(ids: string[]) {
  ids.forEach((id) => pending.add(id));
  clearTimeout(timer);
  timer = setTimeout(flush, BATCH_MS);
}

if (typeof addEventListener === "function") addEventListener("pagehide", () => flush(true));
